import React from 'react';
import PropTypes from 'prop-types';
import {
  Layout,
  Hero,
  Positioning,
  Services,
  Expertise,
  About,
  Directions,
  CTA,
} from '@components';

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <main>
      <Hero />
      <Positioning />
      <Services />
      <Expertise />
      <About />
      <Directions />
      <CTA />
    </main>
  </Layout>
);

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default IndexPage;
